import { combineReducers } from "redux";

import { entitiesReducer } from "../services/entities/reducer";
import { exampleReducer } from "../services/redux-example/reducers";

/**
 * Preserve fields sorting in the reducer
 */
const rootReducers = combineReducers({
  example: exampleReducer,
  entities: entitiesReducer,
});

export default rootReducers;
